import * as React from 'react';
import { useSetInspectorTitle } from 'ra-core';
import { FieldsSelector } from '../../preferences';
export var DatagridEditor = function () {
    useSetInspectorTitle('ra.inspector.Datagrid.title', { _: 'Datagrid' });
    return React.createElement(FieldsSelector, { name: "columns", availableName: "availableColumns" });
};
//# sourceMappingURL=DatagridEditor.js.map